import { render, staticRenderFns } from "./BindPhoneNumber.vue?vue&type=template&id=cf0d94aa&scoped=true&"
import script from "./BindPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./BindPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./BindPhoneNumber.vue?vue&type=style&index=0&id=cf0d94aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0d94aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
